import { createAction } from '@reduxjs/toolkit';

export const LEAVE_CONVERSATION = 'LEAVE_CONVERSATION';
export const leaveConversationAction = createAction(
    LEAVE_CONVERSATION,
    (messageSessionId) => ({
        payload: { messageSessionId }
    })
);
